import { useState } from "react";
import useEffectAfterMount from "./useEffectAfterMount";

/**
 * Custom hook that allows awaiting state changes before executing a callback.
 * @param {Function} updateFunc - Function to update the state.
 * @param {Array} dependencies - Dependencies to monitor for state changes.
 * @param {Function} callback - Callback function to execute after state update.
 * @returns {Object} An object containing the `awaitStateChange` function.
 */
const useAwaitStateChange = (updateFunc, dependencies, callback) => {
  const [stateIsUpdate, setStateIsUpdated] = useState(false);

  useEffectAfterMount(() => {
    setStateIsUpdated(false);
  }, [...dependencies]);

  useEffectAfterMount(() => {
    if (stateIsUpdate && callback) {
      callback();
    }
  }, [stateIsUpdate, callback]);

  const awaitStateChange = (...args) => {
    updateFunc(...args);
    setStateIsUpdated(true);
  };

  return { awaitStateChange };
};

export default useAwaitStateChange;
